import React from 'react';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";

const Body = ({ budgetPlanner }) => (

    <div className="row m-0">
        {
            !budgetPlanner || !budgetPlanner.totalforeachCategory || budgetPlanner.totalforeachCategory.length <= 0 ?
                <NoDataMsg />
                :
                <div>

                    <div className="row m-0">
                        <div className="text-center list_header">
                        </div>
                    </div>

                    <div className="col-lg-12 mt-2">
                        <div className="col-lg-12">
                            <ResponsiveContainer width="100%" height={300}>
                                <BarChart width={730} height={250} data={budgetPlanner.totalforeachCategory.map(x => ({ name: x.name, value: x.sales }))}>
                                    <XAxis dataKey="name" />

                                    <YAxis label={{ value: 'Sales (Dollars)', angle: -90, position: 'insideLeft' }} />
                                    <Tooltip />

                                    <Bar dataKey="value" fill="#7A60E5" />
                                </BarChart>

                            </ResponsiveContainer>
                        </div>
                    </div>

                    <div className="col-lg-12  mt-1">
                        <table className="table table-striped table-hover table-responsive">
                            <thead>
                                <tr>
                                    <th className='tableHeaderColorGray'>Category</th>
                                    <th className='tableHeaderColorGray'>Total Gross Sales</th>
                                    <th className='tableHeaderColorGray'>Percentage</th>
                                    <th className='tableHeaderColorGray'>Suggested Budget</th>
                                </tr>
                            </thead>
                            <tbody className="purpleTextTableReport">
                                {
                                    budgetPlanner.totalforeachCategory ? budgetPlanner.totalforeachCategory.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{item.name}</td>
                                                <td>{getDollarFormat(item.sales)}</td>
                                                <td>{item.percentage + '%'}</td>
                                                <td>{getDollarFormat(item.budget)}</td>
                                            </tr>
                                        )
                                    }) : <tr></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    {budgetPlanner.topCategorySales.map((category, index1) => {
                        return (
                            <div className="col-lg-12  mt-1 ml-0" key={index1}>
                                <h2 className="text-center">{category.name}</h2>
                                <div className="col-lg-12" >
                                    <table className="col-lg-12 table table-striped table-hover table-responsive" >
                                        <thead>
                                            <tr>
                                                <th>Product Name</th>
                                                <th>SKU</th>
                                                <th>Total Gross Sales</th>
                                                <th>Percentage</th>
                                                <th>Suggested Budget</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                category.salesList ? category.salesList.map((item, index2) => {
                                                    return (
                                                        <tr key={index2}>
                                                            <td>{item.name}</td>
                                                            <td>{item.sku}</td>
                                                            <td>{getDollarFormat(item.sales)}</td>
                                                            <td>{item.percentage + '%'}</td>
                                                            <td>{getDollarFormat(item.budget)}</td>
                                                        </tr>
                                                    )
                                                }) : <tr></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }
                    )}

                </div>
        }

    </div>
);



export default Body;